import * as React from "react";
import { Icon } from "sb-resp-ui";

export class ViewAllButton extends React.Component<{
    text: string,
    handler: React.MouseEventHandler<HTMLAnchorElement>,
    link: string
}, {}> {
    render() {
        return (
            <a href={this.props.link} className="rj-superbanner__view-all" onClick={this.props.handler} data-uat="button-superbanner-view-all">
                <span className="rj-superbanner__view-all-text">{this.props.text}</span>
                <Icon i="arrow-flat-right" />
            </a>
        )
    }
}